import axios from 'axios'

const { VUE_APP_PRINTIT_URL } = process.env


const openVoucher = async (bookingName, bookingNumber, voucherNumber, system, sessionid) => {
  const result = { error: false }
  try {
    const fileName = `TF-${bookingNumber}-${voucherNumber}`;
    const url = `${VUE_APP_PRINTIT_URL}/printit/api/viewtrail/vouchers`
    const body = { "bookingName": bookingName, "bookingNumber": bookingNumber, "voucherNumber": voucherNumber, "system": system, "sessionid": sessionid, "platform": "desktop" }
    const response = await axios.post(url, body, { responseType: 'blob' })
    if (response && response.data) {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = fileURL;
      a.setAttribute("download", fileName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(fileURL);
    }
    return result
  } catch (err) {
    result.error = true
    return result
  }
}

export {
  openVoucher
}


